import React from 'react';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';
import Text from '../../../components/Text';
import { getContentKeyAccToLang } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import dynamicfunction from '../../../utils/dynamicfunction';
import Loader from '../../../components/Loader';

const ActionButtons = ({
  onPressView,
  onPressDownload,
  onPressEmail,
  emailLoading,
}) => {
  const { isArabic } = dynamicfunction();
  const { reportsContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(reportsContent, key, isArabic);
  };

  return (
    <div className='flex gap-3 mt-4'>
      <div
        className='flex justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
        onClick={onPressView}
      >
        <ReactSVG src={icons?.view_icon} />
        <Text
          text={getContentKey('view')}
          color='text-primary'
          isTruncate={false}
        />
      </div>

      <div
        className='flex justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
        onClick={onPressDownload}
      >
        <ReactSVG src={icons?.download_icon} />
        <Text
          text={getContentKey('download')}
          color='text-primary'
          isTruncate={false}
        />
      </div>
      <div
        className='flex justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
        onClick={onPressEmail}
      >
        {emailLoading ? (
          <Loader width={'w-4'} height={'h-4'} />
        ) : (
          <>
            <ReactSVG src={icons?.download_icon} />
            <Text
              text={getContentKey('email')}
              color='text-primary'
              isTruncate={false}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ActionButtons;
